import links from 'links'

import messages from './messages'


type Link = {
  to: string
}
type GenderLink = {
  MALE: Link
  FEMALE: Link
}

type Data = {
  title: string | Intl.Message
  actionText: string | Intl.Message
  trackingKey: string
} & Partial<Link> & Partial<GenderLink>

export const defaultNavItems: Data[] = [
  {
    ...messages.quiz,
    to: links.smartRecommendations,
    trackingKey: 'Take our fragrance quiz',
  },
  {
    ...messages.collections,
    MALE: { to: links.collectionsMen },
    FEMALE: { to: links.collectionsWomen },
    trackingKey: 'Browse our curated collections',
  },
]

export const bestsellersNavItems: Data[] = [
  {
    ...messages.home,
    MALE: { to: links.bestsellers.colognes },
    FEMALE: { to: links.bestsellers.perfumes },
    trackingKey: 'Our latest home fragrances',
  },
]

export const theEditNavItems: Data[] = [
  {
    ...messages.theEdit,
    to: links.shop.theEdit,
    trackingKey: 'The edit',
  },
]
